
export default {

    setModesLivraison (state, modesLivraison) {
      state.all = modesLivraison
    }
}